module.exports = __webpack_public_path__ + "img/url-img.4ac8e277.jpg";